import {rei} from "@/services/api"

class CargaService {
  static gerarXml (data) {
    return rei.post(`carga/gerar-xml`, data).then(res => res.data)
  }

  static enviarXmlAssinado (data) {
    return rei.post(`carga/enviar-xml-assinado`, data).then(res => res.data)
  }
}

export default CargaService
